@if (selectedCount()) {
  <ui-button
    (clicked)="addToCartClicked.emit()"
    [loading]="isLoading()"
    icon="cart-shopping"
    iconStyle="light"
  >
    In den Warenkorb ({{ selectedCount() }})
  </ui-button>

  @if (isMobile()) {
    <ui-button
      (clicked)="cancelled.emit()"
      buttonStyle="outlined"
      class="cancel"
      tooltip="Abbrechen"
    >
      <ui-icon faName="xmark" faStyle="light"></ui-icon>
      <span class="cancel-label">Abbrechen</span>
    </ui-button>
  } @else {
    <ui-button (clicked)="cancelled.emit()" buttonStyle="outlined">
      Abbrechen
    </ui-button>
  }
} @else{
  <ui-button buttonStyle="filled" [disabled]="true">Wählen Sie Artikel aus, um sie hinzuzufügen</ui-button>
}
